// 认证相关 API
// V2 认证系统 - 支持 access/refresh token

import { axiosInstance } from "./request";

export interface AuthTokenResponse {
  code: number;
  error: string;
  data: {
    access_token: string;
    refresh_token: string;
    sid: string;
    token_type: string;
    expires_in: number;
    refresh_expires_in: number;
  };
}
export interface AuthCodeResponse {
  code: number;
  error: string;
  data: {
    mode: string;
    email: string;
    ttl_sec: number;
  };
}

export interface LogoutResponse {
  code: number;
  error: string;
  data: {
    sid: string;
    revoked: boolean;
  };
}

/**
 * @param email
 */
export function sendAuthCode(email: string): Promise<AuthCodeResponse> {
  const postData = {
    mode: "email",
    email: email,
  };

  return axiosInstance.post("/auth/v2/user/auth_code/", postData);
}

/**
 * 
 * @param email 
 * @param code 
 */
export function loginWithEmailCode(
  email: string,
  code: string
): Promise<AuthTokenResponse> {
  const postData = {
    channel: "verification_code",
    account_type: "email",
    account: email,
    verification_code: code,
  };

  return axiosInstance.post("/auth/v2/user/token/", postData);
}

/**
 * 刷新 access token
 * @param refreshToken 刷新令牌
 * @param sid 会话 ID
 */
export function refreshAccessToken(
  refreshToken: string,
  sid: string
): Promise<AuthTokenResponse> {
  const postData = {
    refresh_token: refreshToken,
    sid: sid,
  };

  return axiosInstance.post("/auth/v2/user/token/refresh/", postData);
}

/**
 * 登出
 * @param sid 会话 ID
 */
export function logout(sid: string): Promise<LogoutResponse> {
  const postData = {
    sid: sid,
  };

  return axiosInstance.post("/auth/v2/user/token/logout/", postData);
}

/**
 * 使用外部 JWT 登录 (保留用于向后兼容)
 * @param jwt JWT token
 * @param platformId 平台 ID
 */
export function loginWithExternalJWT(
  jwt: string,
  platformId: string
): Promise<any> {
  const postData = {
    channel: "external_jwt",
    external_jwt: jwt,
    external_issuer: platformId,
  };

  return axiosInstance.post("/auth/v2/user/token/", postData);
}

